/**
 * Scope the theme's Bootstrap dropdowns to the theme navbar.
 *
 * theme.js bundles its own Bootstrap, and Plone ships another one. Both
 * register a delegated handler on [data-bs-toggle="dropdown"], so for a menu
 * outside the theme navbar - Plone's toolbar and sidebar, the CMS panels - two
 * independent instances act on the same element. One opens the menu, and the
 * other's clearMenus() reads the "shown" class off the very same DOM node,
 * concludes that its own dropdown is open, and closes it again. The menu
 * flickers or never appears.
 *
 * So the theme's copy owns .navbar and keeps its hands off everything else.
 *
 * This guard belongs in the source, not in assets/js/theme.js. It has been
 * written into the bundled Bootstrap twice before - 77fa1229 is literally
 * called "readded dropdown fix" - and a rebuild discarded it both times, most
 * recently in 45dde9d0, where regenerating the bundle for an unrelated masonry
 * change reverted the class to stock. A patch that only exists in a generated
 * file is a patch with an expiry date.
 */

const Dropdown = window.bootstrap && window.bootstrap.Dropdown

if (Dropdown) {
  const ownedByTheme = (element) =>
    !!(
      element &&
      typeof element.closest === 'function' &&
      element.closest('.navbar')
    )

  // hide() is guarded as well as toggle()/show(): without it the theme's
  // clearMenus() still closes a menu that Plone's Bootstrap had just opened.
  for (const method of ['toggle', 'show', 'hide']) {
    const original = Dropdown.prototype[method]

    Dropdown.prototype[method] = function (...args) {
      if (!ownedByTheme(this._element)) {
        return undefined
      }

      return original.apply(this, args)
    }
  }
}
